export default __webpack_public_path__ + "static/media/web_ico.3797a739.svg";